module.exports = __webpack_public_path__ + "media/cyclone3.bdc79396.webm";